import React, { useContext } from 'react'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import CountryPage from 'Containers/Country/Page'
import PipelineView1 from './PipelineView'
import PipelineView2 from './v2'
import { FeatureFlagsContext } from '../../../../Context/FeatureFlagsContext'

const Pipeline = props => {
  const { country } = props
  const featureFlags = useContext(FeatureFlagsContext)

  return (
    <CountryPage country={country} breadcrumbs={[{ label: 'Pipeline' }]}>
      <LayoutDashboard>
        {featureFlags.campaignPipelineV2 ? (
          <PipelineView2 country={country} />
        ) : (
          <PipelineView1 country={country} />
        )}
      </LayoutDashboard>
    </CountryPage>
  )
}

export default Pipeline
